// 职级
import request from '@/utils/request'

// 添加
export function addRank(data) {
  return request({
    url: '/bsProfessionalLevel/save',
    method: 'post',
    data
  })
}

// /bsProfessionalLevel/delete/{id}
// 删除
export function del(id) {
  return request({
    url: '/bsProfessionalLevel/delete/' + id,
    method: 'delete'
  })
}

// /bsProfessionalLevel/update
// 修改
export function edit(data) {
  return request({
    url: '/bsProfessionalLevel/update',
    method: 'put',
    data
  })
}
